import { connect } from 'react-redux'
import { compose } from 'recompose'
import withTranslation from '../../../globals/components/withTranslation'
import { IReduxStorage } from '../../../store/reducers/types'
import { setCompanyJoinRequests } from '../../../store/actions'
import Component from './component'

export default compose(
  withTranslation,
  connect((state: IReduxStorage) => {
    const {
      auth: { profile },
    } = state

    return { profile: profile.get('data').toJS() }
  }, {
    setCompanyJoinRequests
  })
)(Component)
